export enum AdminPanelTabs {
    VerifiedQuestionsTable = "verifiedQuestionsTable",
    DocumentsTable = "documentsTable",
    DomainTable = "domainTable"
}
